import { NavigationGuard } from "vue-router";
import { authStore } from "@/store/auth";

/**
 * ログインチェック処理
 * @param to
 * @param _from
 * @param next
 */
export const checkLogin: NavigationGuard = (to, _from, next) => {
  // 対象ページがチェック
  if (to.meta?.isBeforeLogin) {
    next();
    return;
  }

  // ログイン中かチェック
  const isExistToken = authStore.existToken;
  if (!isExistToken) {
    // ログインが必要
    next({
      name: "Welcome"
    });
    return;
  }
  next();
};
